import React from "react";
import Big from "big.js";
import CircleChart from "@appComponents/CircleChart/CircleChart";
import { IWalletDetails } from "@market/interfaces/IWallet";

const big = Big();

type Props = {
  colors: string[];
  data: Pick<IWalletDetails, "total_usd" | "currency_name" | "currency">[];
  sum: number;
};
const Chart = ({ data, colors, sum }: Props) => {
  const getPieData = (data: Props["data"]) => {
    const mainShares = data.slice(0, 5);

    const others = data.slice(5);

    const rest = others
      .map((el) => el.total_usd || 0)
      .reduce((prev, curr) => Number(big(prev).add(curr)), 0);

    const labels = mainShares.map((data) => data.currency_name);

    if (data.length > 5) {
      labels.push("Other");
    }

    return {
      data: [...mainShares.map((data) => data.total_usd), rest].filter(
        (x) => !!x
      ),
      labels,
    };
  };

  const chartData = getPieData(data);

  return (
    <CircleChart
      series={chartData.data}
      labels={chartData.labels}
      headline=""
      sum={sum}
      width={"100%"}
      colors={colors}
      options={{
        stroke: {
          colors: undefined,
          width: 1,
        },
        plotOptions: {
          pie: {
            customScale: 1.3,
            offsetY: 30,
            donut: {
              size: "75%",
            },
          },
        },
        tooltip: {
          y: {
            formatter: (value: number) =>
              `&asymp; ${new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                currencyDisplay: "narrowSymbol",
              }).format(value)}`,
            title: {
              formatter: () => "",
            },
          },
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          offsetY: 30,
          markers: {
            width: 12,
            height: 4,
            radius: 2,
          },
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              legend: {
                offsetY: 30,
              },
            },
          },
          {
            breakpoint: 990,
            options: {
              legend: {
                offsetY: 65,
              },
            },
          },
        ],
      }}
    />
  );
};

export default Chart;
